import React from "react";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_phoenix-roof-pro/artifacts/xxcqb6kb_IMG_8218.jpeg";

// The Blessed Roofing sunset emblem (uploaded brand logo).
export const Logo = ({ className = "" }) => {
  return (
    <img
      src={LOGO_URL}
      alt="Blessed Roofing logo"
      className={`object-cover rounded-md ${className}`}
    />
  );
};

export const LogoLockup = ({ inverted = false, className = "" }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <Logo className="h-11 w-11 shrink-0 ring-1 ring-[#D86C1E]/40" />
      <div className="leading-none">
        <div
          className={`font-heading font-black tracking-tight text-lg ${
            inverted ? "text-white" : "text-[#0A0A0A]"
          }`}
        >
          BLESSED ROOFING
        </div>
        <div className="text-[10px] font-bold uppercase tracking-[0.22em] text-[#D86C1E]">
          Schuyler Corder · Pro West
        </div>
      </div>
    </div>
  );
};

export default Logo;
